var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "48px",
        height: "48px",
        viewBox: "0 0 48 48",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Final",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Spring---Active",
                transform: "translate(1.000000, 1.000000)",
                stroke: "#000000",
                "stroke-width": "2"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M26.736,35.092 C24.2470716,36.0699706 21.6000614,36.5837821 18.926,36.608 C12.4580575,36.6075217 6.71879595,32.4611733 4.68667508,26.3207526 C2.65455422,20.180332 4.78726048,13.4288216 9.978,9.57 L10.066,9.494 C10.55,9.038 15.544,4.6 26.926,4.6 C32.4711415,4.86448773 37.9681014,3.45924462 42.706,0.566 C42.9873592,0.373754925 43.3472482,0.338018047 43.6609198,0.471176726 C43.9745915,0.604335405 44.1988646,0.888058509 44.256,1.224 C45.4008252,7.75235813 44.6684231,14.471593 42.144,20.6",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M46,38.234 C45.9734936,40.2920498 45.1010244,42.24845 43.5876364,43.6434154 C42.0742484,45.0383808 40.0533918,45.7489037 38,45.608 C35.9482753,45.7460327 33.9300766,45.0342204 32.4189237,43.6395719 C30.9077709,42.2449235 30.0366689,40.2901897 30.01,38.234 C30.01,34.718 35.08,25.884 37.142,22.434 C37.3226067,22.1323148 37.6483855,21.9476497 38,21.9476497 C38.3516145,21.9476497 38.6773933,22.1323148 38.858,22.434 C40.922,25.886 46,34.718 46,38.234 Z",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M32.01,16.6119911 L31.51,16.6119911 C14.114,16.6 0.01,28.696 0.01,43.6 L0.01,45.6",
                  id: "Path"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56ef5fc5", { render: render, staticRenderFns: staticRenderFns })
  }
}